import React from "react";
import Typography from "@mui/material/Typography";

export default function CSVDetalhesModalTopo(
  props: CSVDetalhesModalTopoPropsTypes
) {
  return (
    <React.Fragment>
      <div className="containerTitle">
        <Typography
          variant="h5"
          fontFamily={"Co Headline Regular"}
          gutterBottom
          align="left"
          marginLeft="15px"
        >
          Detalhes de Upload do CSV de {props.name}
        </Typography>
      </div>
    </React.Fragment>
  );
}

interface CSVDetalhesModalTopoPropsTypes {
  name: string;
}